import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getBrands = async () => {
    const { data, error } = await supabase
        .from('product_brand')
        .select(`*`)

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetAllBrands() {
    return useQuery({
        queryKey: ['useGetAllBrands'],
        queryFn: () => getBrands(),
        staleTime: 0,
    })
}
